import firebase from "firebase/compat/app";
import { getAuth } from "firebase/auth";
import "firebase/compat/firestore";

var firebaseConfig = {
  apiKey: "AIzaSyCF8IY421u6djtfMCTOJ11G8PQnEz30ZIE",
  authDomain: "raffle-mania-ecac1.firebaseapp.com",
  databaseURL: "https://raffle-mania-ecac1-default-rtdb.firebaseio.com",
  projectId: "raffle-mania-ecac1",
  storageBucket: "raffle-mania-ecac1.appspot.com",
  messagingSenderId: "692873605861",
  appId: "1:692873605861:web:8763978ce851394c3c1a0c",
};

const fire = firebase.initializeApp(firebaseConfig);
export const db = fire.firestore();
export const auth = getAuth();
export default fire;
